import { Shield, Phone, CheckCircle2 } from 'lucide-react';
import ContactForm from '../../components/ContactForm';
import SEO from '../../components/SEO';

export default function ServiceDe() {
  const servicePunkter = [
    'Flexible Vereinbarung: Als 6- oder 12-Monats-Servicevertrag wählbar',
    'Komplette technische Durchsicht Ihres Danshakers von A bis Z',
    'Reinigung und professionelle Lackausbesserung, wo nötig',
    'Reinigung und Schmierung aller beweglichen mechanischen Komponenten',
    'Sollten Teile verschleißbedingt ausgetauscht werden müssen, stimmen wir Aufwand und Kosten immer vorab mit Ihnen ab.'
  ];

  return (
    <div className="relative min-h-screen bg-slate-50 text-slate-900 antialiased">
      <SEO
        title="Servicevertrag - Halten Sie Ihren Danshaker in Bestform"
        description="Bestellen Sie einen Servicevertrag für Ihren Danshaker ab 995 DKK zzgl. MwSt. Wir prüfen, reinigen, schmieren und warten Ihre Maschine von A bis Z."
        path="/de/service"
        lang="de"
      />

      {/* Background gradients */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(14,103,162,0.05),transparent_60%)]" />

      {/* Main Content */}
      <section className="mx-auto max-w-7xl px-4 pt-16 pb-20 md:px-8 md:pt-24">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-start">
          {/* Left Column: Info */}
          <div className="lg:col-span-6 space-y-8 lg:sticky lg:top-40">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#0E67A2]/10 px-4 py-1.5 text-xs font-bold text-[#0E67A2]">
                <Shield className="h-3.5 w-3.5" aria-hidden="true" />
                <span>Maschine langfristig in Topform halten</span>
              </div>
              <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
                Servicevertrag
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed">
                Danshaker bietet Ihnen einen attraktiven Servicevertrag (wahlweise im 6- oder 12-Monats-Rhythmus), damit Ihre Maschine dauerhaft zuverlässig und über viele Jahre hinweg optimal arbeitet.
              </p>
            </div>

            {/* Price Box */}
            <div className="rounded-2xl border border-slate-200 bg-white p-6 space-y-2 shadow-xl">
              <span className="block text-xs text-slate-500 font-semibold uppercase tracking-wider">Servicevertrag Preis</span>
              <div className="flex items-baseline gap-2">
                <span className="text-3xl font-black text-[#0E67A2]">kr. 995,-</span>
                <span className="text-sm text-slate-500 font-semibold">exkl. MwSt. *</span>
              </div>
              <p className="text-xs text-slate-400 font-semibold italic border-t border-slate-100 pt-2 mt-2">
                * Zzgl. eventuell anfallender Ersatzteile (wird vorab mit Ihnen abgestimmt)
              </p>
            </div>

            {/* Service Points */}
            <div className="space-y-4">
              <h2 className="text-sm font-bold uppercase tracking-wider text-slate-900">
                Das beinhaltet der Servicevertrag:
              </h2>
              <ul className="space-y-3">
                {servicePunkter.map((punkt, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <CheckCircle2 className="h-5 w-5 text-[#0E67A2] shrink-0 mt-0.5" />
                    <span className="text-sm text-slate-700 leading-relaxed font-medium">
                      {punkt}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Direct Phone Assistance */}
            <div className="rounded-2xl bg-slate-900 text-white p-6 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-lg">
              <div>
                <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Direkter Servicekontakt</p>
                <p className="text-lg font-bold">Haben Sie Fragen zur Wartung?</p>
              </div>
              <a
                href="tel:25303589"
                className="inline-flex items-center gap-2 rounded-xl bg-[#0E67A2] px-5 py-3 text-sm font-bold text-white transition hover:bg-[#0E67A2]/90 shadow-md shrink-0"
              >
                <Phone className="h-4 w-4" />
                +45 2530 3589
              </a>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="lg:col-span-6">
            <div className="rounded-3xl border border-slate-200 bg-white p-6 md:p-8 shadow-2xl">
              <h3 className="text-2xl font-bold text-slate-900 mb-2">
                Servicevertrag anfragen
              </h3>
              <p className="text-sm text-slate-600 mb-6 font-medium">
                Senden Sie uns Ihre Daten, und wir setzen uns umgehend mit Ihnen in Verbindung, um Ihren Serviceplan abzustimmen.
              </p>
              <ContactForm defaultService="Serviceaftale" buttonText="Servicevertrag anfordern" lang="de" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
